export default "__VITE_ASSET__BHoKCiU7__";